<!-- Questions tab parent container for Knowledge Check (GUIDED) simulations.    -->
<!-- details-section provides the title, description, and headerAction slot       -->
<!-- matching the same container used by the Scoring tab in the self-author flow. -->
<!-- Child sections are implemented in separate subtasks:                         -->
<!--   SR-21515: AI review banner (below)                                        -->
<!--   SR-21516: Tips panel                                                       -->
<!--   Separate subtask: Question list                                            -->
<tabs-inner-wrap>
  <details-section
    [title]="'simulationBuilder.TAB_QUESTIONS' | transloco"
    [subtitle]="'simulationBuilder.MESSAGING_SUBTITLE' | transloco"
  >
    <!-- Disabled until scoring a Knowledge Check test session is supported. -->
    <button headerAction qai-button kind="tertiary" size="medium" [disabled]="true">
      {{ 'simulationBuilder.SCORE_LAST_SESSION' | transloco }}
    </button>

    <!-- SR-21515: AI-generated content review banner — non-dismissible -->
    <app-message-block
      contentPlacement="left"
      icon="message-alert-square"
      [featuredIcon]="true"
      iconColor="#000"
    >
      {{ 'simulationBuilder.SCORING_AI_REVIEW_NOTICE' | transloco }}
    </app-message-block>

    <!-- SR-21516: Tips panel -->
    <knowledge-check-tips-panel />

    <knowledge-check-question-section-list />
  </details-section>
</tabs-inner-wrap>
